import { Skeleton } from '@mui/material';

export const AppVisibilityLoadingSkeleton = () => {
  return (
    <div className="w-full flex">
      <div className="w-full flex flex-col gap-3">
        <Skeleton variant="text" width={100} height={16} />
        <Skeleton variant="text" width={160} height={16} />
      </div>
      <Skeleton
        className="rounded"
        variant="rectangular"
        width={60}
        height={30}
      />
    </div>
  );
};
